export const MOTION_PRESETS = {
    linear: {
        container: {
            open: { 
                opacity: 1,
                transition: { 
                    duration: 1
                }
            },
            close: { 
                opacity: 0,
                transition: { 
                    duration: 1
                }
            },
        },
        content: {
            open: { 
                opacity: 1,
                transition: { 
                    duration: 1
                }
            },
            close: { 
                opacity: 0,
                transition: { 
                    duration: 1
                }
            }
        },
    },
    linearBottom: {
        content: {
            open: { 
                opacity: 1,
                y: 0,
                transition: { 
                    duration: 0.7,
                    delay: 0.3
                }
            },
            close: { 
                opacity: 0,
                y: 50,
                transition: { 
                    duration: 1
                }
            }
        },
    },
    spring: {
        container: {
            open: { 
                opacity: 1,
                transition: { 
                    duration: 0.5
                }
            },
            close: { 
                opacity: 0,
                transition: { 
                    duration: 0.5,
                    delay: 0.3
                }
            },
        },
        content: {
            open: { 
                opacity: 1,
                y: 0,
                transition: { 
                    type: 'spring',
                    stiffness: 80,
                    duration: 0.5
                }
            },
            close: { 
                opacity: 0,
                y: -30,
                transition: { 
                    type: 'spring',
                    stiffness: 80,
                    duration: 0.5,
                    delay: 0.3
                }
            }
        },
    },
    springBottom: {
        content: {
            open: { 
                opacity: 1,
                y: 0,
                transition: { 
                    type: 'spring',
                    stiffness: 80,
                    duration: 0.5
                }
            },
            close: { 
                opacity: 0,
                y: 30,
                transition: { 
                    type: 'spring',
                    stiffness: 80,
                    duration: 0.5,
                    delay: 0.3
                }
            }
        },
    },
}